import { useCallback, useEffect, useState} from 'react';

import { ErrorMessage } from '@src/components/ErrorMessage';
import { useRecaptchaLoader } from '@src/hooks/useRecaptchaLoader';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const RECAPTCHA_ID = 'recaptcha-container';


export function RecaptchaV2({formData, onInputChange, recaptchaError, setRecaptchaError, errors, onResetReady}) {
  // console.log(process.env);


  // The reCAPTCHA script is no longer loaded site-wide from index.html; it is
  // injected here, only on pages that actually render a form.
  const { isLoaded } = useRecaptchaLoader();

  const [isRendered, setIsRendered] = useState(false);

  const resetRecaptcha = useCallback(() => {
    if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
      window.grecaptcha.reset();
      onInputChange('recaptchaToken', '');
      setRecaptchaError(false);
    }
  }, [onInputChange, setRecaptchaError]);

  useEffect(() => {
    if (onResetReady) {
      // Call the parent setter to register the function
      onResetReady(resetRecaptcha);
    }
  }, [onResetReady, resetRecaptcha]);

  useEffect(() => {
    // Function to perform the manual render
    const renderRecaptcha = () => {
      if (
        !isRendered && // Only render once
        window.grecaptcha &&
        typeof window.grecaptcha.render === 'function' && // The crucial check!
        document.getElementById(RECAPTCHA_ID)
      ) {
        window.grecaptcha.render(
          RECAPTCHA_ID, // ID of the container element
          {
            sitekey: RECAPTCHA_SITE_KEY,
            callback: (token) => {
              onInputChange('recaptchaToken', token);
              setRecaptchaError(false);
            },
            'expired-callback': () => {
              onInputChange('recaptchaToken', '');
              setRecaptchaError(true);
            },
          },
        );
        setIsRendered(true);
      }
    };

    // useRecaptchaLoader owns script injection and readiness, so this effect
    // just renders once the API is available. The previous window globals
    // (isRecaptchaLoaded / dispatchRecaptchaReady) are gone along with the
    // index.html bootstrap they belonged to.
    if (isLoaded) {
      renderRecaptcha();
    }
  }, [isLoaded, isRendered, onInputChange, setRecaptchaError]);
  return (
    <>
      {/* 💡 reCAPTCHA V2 Checkbox Widget (Now using g-recaptcha and .env key) */}
      <div style={{ borderColor: '#e6e6e6' }} className="p-4 border rounded-lg bg-gray-50">
        <div id={RECAPTCHA_ID}>
          {/* The grecaptcha.render() call will place the widget here */}
        </div>

        {/* Custom error message for reCAPTCHA */}
        {recaptchaError && (
          <p className="mt-2 text-sm text-red-600">
            Please complete the reCAPTCHA verification.
          </p>
        )}

        {formData.recaptchaToken == '' && <ErrorMessage error={errors.recaptchaToken} />}
      </div>
    </>

  );
}
